<template>
  <div class="modal fade" id="modalViewDar" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="max-width: 780px;">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <div>
            <h4 class="modal-title" style="font-weight: bold;">Lihat Dokumen DAR (Damage Analysis Report)</h4>
            <div class="modal-subtitle">Periksa kembali semua informasi dan jika terdapat perubahan, silahkan edit dokumen.</div>
          </div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body px-4 py-3" v-if="darDetail">

          <h5 class="text-center mb-3" style="font-weight: 700;">Damage Analysis Report</h5>

          <table class="dar-header-table mb-4">
            <tr>
              <td class="dar-header-label">No. Tiket</td>
              <td>{{ ticketNo }}</td>
            </tr>
            <tr>
              <td class="dar-header-label">Tanggal Dibuat</td>
              <td>{{ formattedCreatedDate }}</td>
            </tr>
            <tr>
              <td class="dar-header-label">Dibuat Oleh</td>
              <td>{{ createdByName }}</td>
            </tr>
          </table>

          <h6 class="mb-2" style="font-weight: 700;">A. Informasi Produk</h6>
          <table class="dar-info-table mb-4">
            <tr>
              <td>No. Order</td>
              <td>{{ product.orderId || '-' }}</td>
            </tr>
            <tr>
              <td>Tipe Produk</td>
              <td>{{ product.productType || '-' }}</td>
            </tr>
            <tr>
              <td>Kode Produk</td>
              <td>{{ product.productCode || '-' }}</td>
            </tr>
             <tr>
              <td>No. Serial</td>
              <td>{{ product.serialNumber || '-' }}</td>
            </tr>
            <tr>
              <td>Spesifikasi</td>
              <td>{{ product.specification || '-' }}</td>
            </tr>
            <!-- <tr>
              <td>BOM Items</td>
              <td>
                <template v-if="(product.bomItems || []).length">
                  <div v-for="(item, index) in product.bomItems" :key="`bom-${index}`">
                    {{ item.component }} : {{ item.name }} (Qty : {{ item.qty }})
                  </div>
                </template>
                <template v-else>-</template>
              </td>
            </tr> -->
          </table>

          <h6 class="mb-2" style="font-weight: 700;">B. Foto Produk</h6>
          <div class="dar-photo-row mb-4">
            <template v-if="(darDetail.photos || []).length">
              <a
                v-for="(url, index) in darDetail.photos"
                :key="`photo-${index}`"
                :href="url"
                target="_blank"
                rel="noopener"
                class="dar-photo-thumb"
              >
                <img :src="url" alt="Foto produk">
              </a>
            </template>
            <template v-else>-</template>
          </div>

          <h6 class="mb-2" style="font-weight: 700;">C. Identifikasi Masalah & Pemeriksaan Awal</h6>
          <table class="dar-info-table mb-4">
            <tr>
              <td>Temuan Teknisi</td>
              <td>{{ darDetail.technicianFindings || '-' }}</td>
            </tr>
            <tr>
              <td>Komponen Rusak</td>
              <td>{{ darDetail.damagedComponents || '-' }}</td>
            </tr>
            <tr>
              <td>Komponen Lainnya</td>
              <td>{{ darDetail.otherComponents || '-' }}</td>
            </tr>
            <tr>
              <td>Kategori Kerusakan</td>
              <td>
                <div class="d-flex flex-wrap" style="gap: 16px;">
                  <label class="dar-checkbox-inline" v-for="opt in damageCategoryOptions" :key="opt.value">
                    <input type="checkbox" disabled :checked="darDetail.damageCategory === opt.value">
                    {{ opt.label }}
                  </label>
                </div>
              </td>
            </tr>
          </table>

          <h6 class="mb-1" style="font-weight: 700;">D. Solusi Yang Disarankan</h6>
          <div class="mb-2 text-muted" style="font-size: 13px;">Berdasarkan hasil pemeriksaan, komponen berikut direkomendasikan untuk diganti.</div>
          <table class="dar-parts-table mb-2">
            <tr>
              <th>Nama Part</th>
              <th class="text-right">Perkiraan Harga (Rp)</th>
            </tr>
            <tr v-if="!clientParts.length">
              <td colspan="2" class="text-center text-muted">Tidak ada part yang ditagihkan ke client</td>
            </tr>
            <tr v-for="(part, index) in clientParts" :key="`part-${index}`">
              <td>{{ part.partName }}</td>
              <td class="text-right">{{ formatRupiah(part.estimatedPrice) }}</td>
            </tr>
            <tr class="dar-parts-total">
              <td>Total Harga</td>
              <td class="text-right">{{ formatRupiah(totalHarga) }}</td>
            </tr>
          </table>
          <div class="mb-4" style="font-size: 13px; font-style: italic;" v-if="darDetail.notes">
            Catatan: {{ darDetail.notes }}
          </div>

          <div class="dar-signature">
            <div>PT Teknologi Skoring Nusantara</div>
            <div class="dar-signature-space"></div>
            <!-- <div class="dar-signature-name">{{ createdByName }}</div> -->
            <div>PIC IT Support</div>
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer justify-content-end">
          <button type="button" class="btn btn-outline-primary" @click="handleEdit" v-if="allowEditDarDoc">
            Edit Dokumen
          </button>
          <button type="button" class="btn btn-primary" @click="$emit('download')" :disabled="loadingDownload" v-if="allowViewDarDoc">
            Download
            <img src="@/assets/images/2.gif" style="height: 18px; margin-left: 4px;" v-if="loadingDownload">
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalViewDar',
  props: {
    darDetail: { type: Object, default: null },
    loadingDownload: { type: Boolean, default: false },
    createdBy: { type: String, default: '' },
  },
  data() {
    return {
      allowEditDarDoc: false,
      allowViewDarDoc: false,
      damageCategoryOptions: [
        { value: 'ringan', label: 'Ringan' },
        { value: 'sedang', label: 'Sedang' },
        { value: 'berat', label: 'Berat' },
      ],
    }
  },
  computed: {
    ticketNo() {
      return (this.darDetail && this.darDetail.ticket && this.darDetail.ticket.ticketNo) || '-'
    },
    hasSavedDar() {
      // root-level createdAt is the DAR record's own timestamp - empty until it has
      // been saved as draft or submitted at least once, unlike ticket.createdDate
      // which always exists (that's the ticket's own creation date, not the DAR's)
      return !!(this.darDetail && this.darDetail.createdAt)
    },
    createdByName() {
      if (this.hasSavedDar) {
        return this.darDetail.ticket.createdBy
      }
      return this.createdBy || '-'
    },
    product() {
      return (this.darDetail && this.darDetail.product) || {}
    },
    formattedCreatedDate() {
      if (this.hasSavedDar) {
        return this.formatIndoDate(this.darDetail.ticket.createdDate)
      }
      return this.formatIndoDate(this.getToday())
    },
    clientParts() {
      return ((this.darDetail && this.darDetail.parts) || []).filter(p => p.coveredBy === 'client')
    },
    totalHarga() {
      return this.clientParts.reduce((sum, p) => sum + (p.estimatedPrice || 0), 0)
    },
  },
  methods: {
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '7.5') {
          this.allowViewDarDoc = true
        }
        if (this.permission[i] == '7.6') {
          this.allowEditDarDoc = true
        }
      }
    },
    getToday() {
      const d = new Date()
      const pad = n => n.toString().padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },
    formatIndoDate(raw) {
      if (!raw) return '-'
      const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      const [datePart] = raw.split(' ')
      const [year, month, day] = datePart.split('-')
      return `${parseInt(day, 10)} ${months[parseInt(month, 10) - 1]} ${year}`
    },
    formatRupiah(angka) {
      const numberString = (angka || 0).toString().replace(/[^,\d]/g, '')
      const split = numberString.split(',')
      const sisa = split[0].length % 3
      const rupiah = split[0].substr(0, sisa)
      const ribuan = split[0].substr(sisa).match(/\d{3}/gi)
      if (ribuan) {
        return sisa ? `${rupiah}.${ribuan.join('.')}` : ribuan.join('.')
      }
      return (parseInt(angka, 10) || 0).toString()
    },
    handleEdit() {
      $('#modalViewDar').modal('hide')
      this.$emit('edit')
    },
  },
  created() {
    this.cekPermission()
  }
}
</script>

<style scoped>
.modal-subtitle {
  font-size: 13px;
  color: #6C757D;
  margin-top: 4px;
  font-weight: normal;
}

.dar-header-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #E5E8EC;
}

.dar-header-table td {
  padding: 8px 12px;
  border: 1px solid #E5E8EC;
  font-size: 14px;
}

.dar-header-label {
  background-color: #EAF4FF;
  font-weight: 600;
  color: #2E3646;
  width: 35%;
}

.dar-info-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #E5E8EC;
}

.dar-info-table td {
  padding: 8px 12px;
  border: 1px solid #E5E8EC;
  font-size: 14px;
  vertical-align: top;
}

.dar-info-table td:first-child {
  width: 30%;
  font-weight: 500;
}

.dar-info-table tr:nth-child(even) {
  background-color: #F8F9FB;
}

.dar-photo-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.dar-photo-thumb {
  display: block;
  width: 90px;
  height: 90px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E5E8EC;
}

.dar-photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dar-checkbox-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: normal;
  margin-bottom: 0;
}

.dar-parts-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #E5E8EC;
}

.dar-parts-table th,
.dar-parts-table td {
  padding: 8px 12px;
  border: 1px solid #E5E8EC;
  font-size: 14px;
}

.dar-parts-table th {
  background-color: #F1F3F6;
  font-weight: 600;
}

.dar-parts-total {
  font-weight: 700;
  background-color: #F8F9FB;
}

.dar-signature {
  text-align: right;
  font-size: 14px;
}

.dar-signature-space {
  height: 48px;
}

.dar-signature-name {
  font-weight: 700;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Resolution/CustomComponent/DAR/ModalViewDar.vue